import { ArrowLeftIcon, ChevronLeft, ChevronLeftIcon } from 'lucide-react';

import { Button } from '@shadcn/ui/components/ui/button';
import { cn } from '@shadcn/ui/lib/utils';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '@shadcn/ui/components/ui/avatar';

export const ActionChatHeader = ({ className }: { className?: string }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const threadId = searchParams.get('threadId') || undefined;
    return (
        <header
            className={cn(
                'sticky flex top-0 w-full min-w-full h-14 border-b px-4 items-center gap-4 animate-fade-in-0-2',
                className
            )}
        >
            <Button
                variant="ghost"
                size="icon"
                className={cn('flex items-center gap-2')}
                onClick={() => {
                    navigate({
                        pathname: '/new/actions-v2',
                        search: '?threadId=' + threadId,
                    });
                }}
            >
                <ChevronLeft className="h-6 w-6" />
            </Button>
            <Avatar className="bg-background-tertiary">
                <AvatarImage
                    className="object-contain scale-[0.70]"
                    src="/images/logos/andsend-icon-striped-color.png"
                />
                <AvatarFallback>C</AvatarFallback>
            </Avatar>
            <div className="flex flex-col gap-0">
                <div className="flex gap-2 items-center">
                    <span className="font-medium text-lg line-clamp-1 text-nowrap capitalize">Andsend</span>
                </div>
                <span className="text-xs text-text-tertiary line-clamp-1 capitalize">Your agent</span>
            </div>
        </header>
    );
};
